<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
    <path fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9 1a8 8 0 1 0 0 16 8 8 0 0 0 8-8"/>
</svg>
